// src/pages/HomePage.js
import React from 'react';
// Import your existing components
import { Hero, FeaturedNews, Features, NewsletterSignup } from '../App';

const HomePage = () => (
  <div className="min-h-screen">
    <Hero />
    <FeaturedNews />
    <Features />
    <NewsletterSignup />
  </div>
);

export default HomePage;